import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, aboutStats } from '@/mocks/articles';

export default function Home() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [featuredHovered, setFeaturedHovered] = useState<number | null>(0);

  const hotArticles = [...articles].sort((a, b) => b.hotIndex - a.hotIndex);
  const featuredArticles = articles.slice(0, 3);
  const latestArticles = articles.slice(0, 8);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51爆料网',
    url: 'https://eeeeme.cn',
    description: '51爆料网为您提供app下载与官网入口，每日更新51吃瓜爆料网黑料不打烊及每日大赛内容。作为实时追踪网红黑料与吃瓜爆料的平台，这里汇聚热门事件独家爆料。',
  };

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51爆料网',
    url: 'https://eeeeme.cn',
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51爆料网首页 - 每日大赛黑料不打烊',
    description: '51爆料网首页，每日更新热门网红黑料、娱乐圈八卦、吃瓜爆料内容，黑料不打烊实时更新。',
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51爆料网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51爆料网是一个实时追踪网红黑料与吃瓜爆料的专业平台，每日更新娱乐八卦、网红爆料、明星动态等热门内容，包含黑料不打烊、每日大赛等特色栏目。',
        },
      },
      {
        '@type': 'Question',
        name: '51爆料网app如何下载？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '访问51爆料网官网，在首页底部或下载引导区可以找到APP下载入口。目前支持iOS和Android双平台下载。',
        },
      },
      {
        '@type': 'Question',
        name: '51爆料网内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51爆料网全天候实时更新，黑料不打烊栏目24小时不间断推送最新爆料内容，确保用户第一时间获取最新资讯。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20abstract%20background%20with%20dramatic%20warm%20red%20and%20deep%20amber%20lighting%20gradients%20luxurious%20texture%20subtle%20spotlight%20effect%20editorial%20quality%20no%20text%20clean%20composition&width=1600&height=900&seq=hero-bg-home-01&orientation=landscape"
              alt="51爆料网 - 实时追踪网红黑料与吃瓜爆料"
              title="51爆料网首页背景"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
            <div className="relative z-10 w-full text-center px-4 md:px-6">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight tracking-tight">
                实时追踪网红黑料
              </h1>
              <p className="text-lg md:text-2xl font-bold text-background-50 mt-3">
                吃瓜爆料 · 每日更新
              </p>
              <p className="text-sm md:text-base text-background-200 mt-4 max-w-2xl mx-auto leading-relaxed">
                汇聚全网最热娱乐八卦与独家爆料，黑料不打烊，每日大赛实时追踪，吃瓜群众的第一选择
              </p>
              <div className="mt-7 flex items-center justify-center gap-3 flex-wrap">
                <a
                  href="#hot"
                  className="px-6 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  立即吃瓜
                </a>
                <a
                  href="#download"
                  className="px-6 py-2.5 rounded-full text-sm font-medium bg-white/15 text-background-50 hover:bg-white/25 backdrop-blur-sm transition-colors whitespace-nowrap"
                >
                  APP下载
                </a>
              </div>
            </div>
          </section>

          <section id="hot" className="py-14 md:py-16 px-4 md:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
                  热门爆料
                </h2>
                <p className="text-sm text-foreground-500 mt-1">实时更新 · 黑料不打烊</p>
              </div>
              <Link
                to="/category/meiri-dasai"
                className="text-sm text-accent-500 hover:text-accent-600 font-medium whitespace-nowrap transition-colors"
              >
                查看全部 →
              </Link>
            </div>

            <div className="relative">
              <button
                onClick={scrollLeft}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-200 text-foreground-700 hover:bg-background-100 hover:border-background-300 transition-all"
              >
                <i className="ri-arrow-left-s-line w-4 h-4 flex items-center justify-center"></i>
              </button>

              <div
                ref={scrollRef}
                className="flex gap-5 overflow-x-auto scrollbar-hide pb-2 px-1"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              >
                {hotArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    excerpt={article.excerpt}
                    category={article.category}
                    categorySlug={article.categorySlug}
                    hotIndex={article.hotIndex}
                    readCount={article.readCount}
                    imageUrl={article.imageUrl}
                  />
                ))}
              </div>

              <button
                onClick={scrollRight}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-background-50 border border-background-200 text-foreground-700 hover:bg-background-100 hover:border-background-300 transition-all"
              >
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
          </section>

          <section className="py-14 md:py-16 px-4 md:px-6 lg:px-8 bg-background-100/50">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2">
              独家深度爆料
            </h2>
            <p className="text-sm text-foreground-500 mb-8">重磅深挖，还原事件真相</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {featuredArticles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className={`group relative rounded-lg overflow-hidden transition-all duration-500 no-underline ${
                    featuredHovered === index ? 'md:col-span-1' : ''
                  }`}
                  style={{ height: '420px' }}
                  onMouseEnter={() => setFeaturedHovered(index)}
                  onMouseLeave={() => setFeaturedHovered(0)}
                >
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className={`absolute inset-0 w-full h-full object-cover transition-transform duration-700 ${
                      featuredHovered === index ? 'scale-105' : 'scale-100'
                    }`}
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <span className="inline-block px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 mb-3 whitespace-nowrap">
                      {article.category}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-background-50 leading-snug mb-2">
                      {article.title}
                    </h3>
                    {(featuredHovered === index || index === 0) && (
                      <p className="text-sm text-background-200 leading-relaxed line-clamp-3 transition-all duration-300">
                        {article.excerpt}
                      </p>
                    )}
                    <div className="flex items-center gap-3 mt-3">
                      <span className="text-xs text-background-300">
                        <i className="ri-eye-line mr-1 w-3 h-3 inline-flex items-center justify-center"></i>
                        {article.readCount}
                      </span>
                      <span className="text-xs text-background-300">
                        <i className="ri-time-line mr-1 w-3 h-3 inline-flex items-center justify-center"></i>
                        {article.publishDate}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>

          <section className="py-14 md:py-16 px-4 md:px-6 lg:px-8">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8">
              最新爆料
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 no-underline"
                >
                  <div className="relative h-40 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                    <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs bg-accent-500 text-background-50 whitespace-nowrap">
                      {article.category}
                    </span>
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.excerpt}</p>
                    <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-100">
                      <span className="text-xs text-foreground-400">{article.publishDate}</span>
                      <span className="text-xs text-foreground-400">
                        <i className="ri-eye-line mr-1 w-3 h-3 inline-flex items-center justify-center"></i>
                        {article.readCount}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <div className="mt-8 text-center">
              <Link
                to="/category/meiri-dasai"
                className="inline-flex items-center gap-1 px-6 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                查看更多爆料
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </section>

          <section id="download" className="flex flex-col lg:flex-row">
            <div className="lg:w-1/2 relative h-[360px] lg:h-[500px] overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20news%20app%20interface%20with%20red%20accent%20colors%20on%20minimal%20cream%20background%20soft%20lighting%20clean%20composition%20editorial%20style%20product%20photography%20elegant&width=1200&height=800&seq=cta-download-left-01&orientation=portrait"
                alt="51爆料网APP界面"
                title="51爆料网APP下载"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
              <div className="absolute bottom-8 left-8">
                <p className="text-xs text-background-200 uppercase tracking-wider mb-1">51爆料网 APP</p>
                <h2 className="text-3xl md:text-4xl font-black text-background-50 leading-none">
                  随时随地
                </h2>
                <h2 className="text-3xl md:text-4xl font-black text-background-50 leading-none">
                  吃瓜第一线
                </h2>
              </div>
            </div>

            <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-14">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center">
                下载51爆料网APP
              </h2>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mt-1">
                黑料实时推送不遗漏
              </h3>
              <p className="text-sm text-foreground-500 text-center mt-6 max-w-md leading-relaxed">
                支持iOS和Android双平台下载，安装后开启推送通知，第一时间获取最新爆料、吃瓜资讯和独家深度内容。更有专属APP用户福利等你来领。
              </p>
              <div className="mt-8 flex items-center gap-4 flex-wrap justify-center">
                <a
                  href="#"
                  className="flex items-center gap-2 px-5 py-3 rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">App Store 下载</span>
                </a>
                <a
                  href="#"
                  className="flex items-center gap-2 px-5 py-3 rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm font-medium">Android 下载</span>
                </a>
              </div>
              <div className="mt-8 grid grid-cols-3 gap-6 text-center">
                {aboutStats.slice(0, 3).map((stat) => (
                  <div key={stat.label}>
                    <p className="text-2xl md:text-3xl font-black text-accent-500">
                      {stat.value}{stat.suffix}
                    </p>
                    <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}